<script>
import Layout from '@layouts/main.vue'

export default {
  page: {
    title: 'Player Vs',
    meta: [{ name: 'description', content: 'The Player Vs page.' }],
  },
  components: { Layout },
  props: {
    playerAId: {
      type: Number,
      required: true,
    },
    playerBId: {
      type: Number,
      required: true,
    },
    compareData: {
      type: Object,
      required: true,
    },
  },
  mounted() {},
}
</script>

<template>
  <Layout>
    <h1> Player Vs</h1>

    {{ playerAId }} VS {{ playerBId }}
  </Layout>
</template>
